import { cx } from "@suse-o11y/class-variance";
import React from "react";

import styles from "./_dropdown-menu.module.css";

const LazyItem = React.lazy(async () => {
	// biome-ignore lint/style/noRestrictedImports: component usage
	const { Item } = await import("@radix-ui/react-dropdown-menu");

	return { default: Item };
});

export type DropdownMenuItemProps = React.ComponentProps<typeof LazyItem>;

export const DropdownMenuItem = React.forwardRef<React.ComponentRef<typeof LazyItem>, DropdownMenuItemProps>(
	({ className, ...props }, ref) => (
		// suspense to prevent Slot injection failing
		<React.Suspense>
			<LazyItem className={cx(styles.item, className)} ref={ref} {...props} />
		</React.Suspense>
	),
);

if (import.meta.env.DEV) {
	DropdownMenuItem.displayName = "DropdownMenuItem";
}
